import React from 'react';
import { Outlet } from "react-router-dom";
import Navbar from '../Nav/Navbar.tsx';

const Wrap = () => {
    return (
        <div id="wrap">
            <Navbar />
            <div className="main-content">
                <Outlet />
            </div>
        </div>
    )
}

export default Wrap;